import Vue from 'vue'
import configs from '@/config'
import store from '@/vuex/store'
import SlideApi from '@/api/slide'

let resource = null

const actions = {
  deleteCountingUnique: {
    method: 'DELETE',
    url: `${configs.liveProxyUrl}/api/live/counting/unique`,
  },
  deleteCountingUniqueNewKafka: {
    method: 'DELETE',
    url: `${configs.liveProxyUrl}/api/${configs.LiveProxyRootPath}/counting/unique`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const deleteCountingUnique = async (payload) => {
  if (store.getters['featureToggles/canUseLiveHostToken']) {
    const { id: presentationId } = store.state.presentation
    const body = { ...payload, presentationId }
    const send = (options) => Vue.http.delete(actions.deleteCountingUnique.url, { body, ...options })
    return SlideApi.sendWithLiveHostToken(presentationId, send)
  }
  return resource.deleteCountingUnique({}, payload)
}

export default {
  initResource,
  deleteCountingUnique,
}
